<template>
  <button ref="buttonRef" class="pill">{{ text }}</button>
</template>
<script setup lang="ts">
import { defineProps, withDefaults, ref, onMounted, defineExpose } from "vue";
interface Props {
  text: string;
  color: string;
  maxHeight?: string;
}
const props = withDefaults(defineProps<Props>(), {});

const buttonRef = ref<HTMLButtonElement | null>();

onMounted(() => {
  if (props.maxHeight && buttonRef.value) {
    buttonRef.value.style.maxHeight = props.maxHeight;
  }
});

defineExpose({
  buttonRef,
});
</script>
<style scoped lang="scss">
button.pill {
  display: inline-block;
  background: black;
  border-radius: 30px;
  color: white;
  line-height: 22px;
  font-size: 11px;
  margin-left: 4px;
  padding: 0 14px;
  font-family: "Montserrat", arial, sans-serif;
  font-weight: 600;
  vertical-align: super;
  &.red {
    color: #c4554d;
    background-color: #faecec;
  }
  &.orange {
    color: #cc772f;
    background-color: #f8ecdf;
  }
  &.yellow {
    color: #c29243;
    background-color: #faf3dd;
  }
  &.green {
    color: #548064;
    background-color: #eef3ed;
  }
  &.blue {
    color: #477da5;
    background-color: #e9f3f7;
  }
  &.purple {
    color: #a48bbe;
    background-color: #f6f3f8;
  }
  &.gray {
    color: #787774;
    background-color: #f1f1ef;
  }
}
</style>
